import { PortfolioNft, SUPPORTED_NETWORKS } from "@cede/types";

const networkMapper: Record<string, string> = {
  [SUPPORTED_NETWORKS.ARBITRUM]: "arbitrum",
  [SUPPORTED_NETWORKS.AVAX]: "avalanche",
  [SUPPORTED_NETWORKS.BSC]: "bsc",
  [SUPPORTED_NETWORKS.ETH]: "ethereum",
  [SUPPORTED_NETWORKS.KLAY]: "klaytn",
  [SUPPORTED_NETWORKS.OPTIMISM]: "optimism",
  [SUPPORTED_NETWORKS.MATIC]: "matic",
  [SUPPORTED_NETWORKS.SOL]: "solana",
};

export function getOpenSeaNftUrl(nft: PortfolioNft) {
  const mappedNetwork = networkMapper[nft.network];
  if (!mappedNetwork) return null;
  return `https://opensea.io/assets/${mappedNetwork}/${nft.tokenAddress}`;
}
